<content>
    <form [formGroup]="licenciasForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-3">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencias.productor' | translate}} *</label>
            <input type="text" formControlName="productor" readonly>
        </div>
        <div class="entry-3">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencias.licencia' | translate}} *</label>
            <input type="text" formControlName="licencia">
        </div>
    </form>
    <footer class="button-bar-right">
        <button (click)="add()">{{'global.insertar' | translate}}</button>
    </footer>
    <table>
        <thead>
            <tr>
                <th class="id">{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencias.id' | translate}}</th>
                <th class="string">{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencias.productor' | translate}}</th>
                <th class="string">{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencias.titulo' | translate}}</th>
                <th class="actions">{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencias.acciones' | translate}}</th>
            </tr>
        </thead>
        <tbody *ngFor="let licencia of licenciasProductorCultivo">
            <tr>
                <td class="string">{{licencia.id}}</td>
                <td class="string">{{desProductor}}</td>
                <td class="string">{{licencia.nLicencia}}</td>
                <td class="actions">
                    <i class="far fa-trash-alt"
                      (click)="askDelete(licencia)" title="{{'titles.eliminar' | translate}}"></i>
                </td>
            </tr>
        </tbody>
        <tfoot *ngIf="!licenciasProductorCultivo || (licenciasProductorCultivo && licenciasProductorCultivo.length < 1)">
            <tr>
              <td colspan="4">
                {{'global.noContent' | translate}}
              </td>
            </tr>
        </tfoot>
    </table>
</content>
<footer class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeDeleteModal()">{{'global.cancelar' | translate}}</button>
        <button (click)="delete()">{{'global.confirmar' | translate}}</button>
      </footer>
    </div>
</div>
